import findKey from 'lodash/findKey';
export const findTabWithRoute = (tabs, pathname) => {
	const path = pathname?.toLowerCase();
	return findKey(tabs, (tab) => {
		const tabRoute = tab?.route?.toLowerCase();
		if (!tabRoute || !path) { return false; }
		if (path === tabRoute) { return true; }
		if (path.startsWith(tabRoute + '/')) { return true; }
		return false;
	});
};
export const getDefaultTab = (tabOptions, pathname, defaultTab) => {
	const tabFromRoute = findTabWithRoute(tabOptions, pathname);
	return tabFromRoute ? tabFromRoute : defaultTab;
};
